var _rect, _polygon, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPortugal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "30.72 85.333 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.72,
    y: 85.333,
    width: 24,
    height: 17,
    fill: "#d80027",
    strokeWidth: 0.048318
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.046875 0 0 .049806 30.72 81.083)",
    points: "196.64 261.56 196.64 426.66 0 426.66 0 85.337 196.64 85.337",
    fill: "#6da544"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.048318
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.938,
    cy: 93.833,
    rx: 3,
    ry: 3.1876,
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.25 92.239v1.9923c0 0.99024 0.75553 1.793 1.6875 1.793 0.93197 0 1.6875-0.80277 1.6875-1.793v-1.9923z",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.937 94.829c-0.31017 0-0.5625-0.2681-0.5625-0.59767v-0.79689h1.125v0.79689c-4.6e-5 0.32952-0.25242 0.59767-0.56255 0.59767z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortugal);
export default __webpack_public_path__ + "static/media/portugal.f0b8dd587374f35b91ccb031aae4d597.svg";
export { ForwardRef as ReactComponent };